import {
  SURVEY_BUILDER_SET_LIST,
  SURVEY_BUILDER_SET_COUNT,
} from './events';

export const setSurveyList = surveys => ({
  type: SURVEY_BUILDER_SET_LIST,
  surveys,
});

export const setSurveyCount = count => ({
  type: SURVEY_BUILDER_SET_COUNT,
  count,
});

